<template>
    <!-- 企业卡  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :rightBg2="rightBg2" :partition="[6, 6]" :rbgStyle="{
            position: 'relative',
            right: '-70px',
            bottom: '-100px'
        }" :rbg2Style="{
            position: 'relative',
            zIndex: 1
        }" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'enterprise',
    components: {
        SubPage
    },
    data() {
        return {
            rightBg: "/img/pay/0--59.png",
            rightBg2: "/img/pay/0--40.png",
            bg: "/img/pay/0-_BG-3.png",
        }
    },
    computed: {
        title() {
            return this.$t('enterprise.title');
        },
        subtitle() {
            return this.$t('enterprise.subtitle');
        },
        description() {
            return [this.$t('enterprise.description1'),
            this.$t('enterprise.description2'),
            this.$t('enterprise.description3')];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>